//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------

export const handleListGalleryImage = (offset, limit) => async (dispatch) => {
    try {
        const response = await apis.get('one_game_gallery', `/get_image_gallery/${offset}/${limit}`);
        if (response && response.success) {
            dispatch(Actions.listimageGallery(response.data));
        }
        return response
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error listing gallery images',
                error,
                module: 'IMAGE_GALLERY',
                operation: 'LIST_GALLERY_IMAGES'
            });
        }
    }
};
export const handleCreateGalleryImage = (url) => async (dispatch) => {
    try {
        const response = await apis.post('one_game_gallery', `/create_gallery`, {
            body: { url }
        });
        if (response && response.success && response.data) {
            dispatch(Actions.createimageGallery(response.data));
        }
        return response
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error creating gallery image',
                error,
                module: 'IMAGE_GALLERY',
                operation: 'CREATE_GALLERY_IMAGE'
            });
        }
    }
    return null;
};
export const handleDeleteGalleryImage = (id) => async (dispatch) => {
    try {
        const response = await apis.del('one_game_gallery', `/delete_gallery/${id}`);
        if (response && response.success && response.data) {
            dispatch(Actions.deleteimageGallery({ id }));
        }
        return response
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error deleting gallery image',
                error,
                module: 'IMAGE_GALLERY',
                operation: 'DELETE_GALLERY_IMAGE'
            });
        }
    }
};